<template lang="html">
    <dropdown class="dropdown dropdown_full-width dropdown_style-1">
        <a class="dropdown-trigger dropdown-toggle">
            <span class="cap-icon cap-icon-menu-hamburger cap-icon_circle center-block"></span>
        </a>
        <template v-slot:dropdown>
        <!-- ul :id="dropdownControlId"
            class="dropdown-menu" -->
            <li :class="repeatLIClass" v-if="document.repeatable">
                <a :href="repeatUrl">Повторить платеж</a>
            </li>
            <li>
                <a :href="correspondentSearchUrl">Поиск по этому корреспонденту</a>
            </li>
        </template>
    </dropdown>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {Dropdown} from 'uiv';

// Vue.use(uiv);

    @Component({
      name: 'history-document-controls',
      components: {Dropdown}
    })
export default class DocumentControls extends Vue {
        @Prop({ required: true })
        document: any

        @Prop({ default: '' })
        repeatUrl!: string

        @Prop({ default: '' })
        correspondentSearchUrl!: string

        get dropdownControlId(): string {
          return `dropdown_doc_${this.document.id}`;
        }

        get dropdownControlIdLink(): string {
          return `#${this.dropdownControlId}`;
        }

        get repeatLIClass(): any {
          return { disabled: !this.document.repeatable };
        }
}
</script>

<style scoped lang="less">
.dropdown {
    > a.dropdown-trigger {
        cursor: pointer;
        cursor: hand;
    }
}
</style>
